import {
  ICustomerEntity,
  SyncJobStatus,
} from '@boma/supplier-portal/shared/entities';

export interface IProductAddToListResponse {
  successCount: number;
  failedCount: number;
  success: ISyncProductListResponse[];
  failed: ISyncProductFailedListResponse[];
}

export interface IExportProductResponse {
  item: {
    id: string;
    name: string;
  };
  failureReason: string;
}

export interface IAccountingPlatformDetails {
  id: string;
  accountingPlatform: AccountingPlatformType;
  companyId: string;
  lastUpdated: string;
}

export interface ISyncProductListResponse extends ISyncItemBase {
  entityAccountingPlatform: IAccountingPlatformDetails;
  product: {
    id: string;
    name: string;
  };
}

export interface ISyncItemBase {
  latestSyncJobDetails?: ISyncJobDetails;
  latestSuccessfulSyncJobDetails?: ISyncJobDetails;
}

// Details of a sync job for a single item
export interface ISyncJobDetails {
  id: string;
  syncJobStatus: SyncJobStatus;
  // When the sync job was created
  createdAt: Date;
  // Why the sync failed
  failureReason: string;
  // When the item was processed
  processedAt?: Date;
}

export interface ISyncProductFailedListResponse {
  item: {
    id: string;
    name: string;
  };
  message: string;
  date: string;
}

export interface IExportCustomerResponse extends ISyncItemBase {
  entityCustomer: ICustomerEntity;
  entityAccountingPlatform: IAccountingPlatformDetails;
  accountingPlatformCustomerId: string;
}

export interface IExportSalesResponse {
  id: string;
  orderId: number;
  companyId: string;
  reason: string;
}

export interface IExportCredentials {
  sageCredentials: {
    username: string;
    password: string;
  };
}

export enum AccountingPlatformType {
  SageOne,
  Xero,
}
